const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcioInscripcio = async (id_inscripcio: string, page: string, inscripcio: any) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions/${id_inscripcio}/inscripcio`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(inscripcio)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
